import { our_services as initializeBlock } from '../../blocks/our_services/index.js';

const runBlock = () => initializeBlock(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runBlock, { once: true });
} else {
  runBlock();
}
